{ "closeAria": "Fermer", "historyAria": "Historique des demandes", "supportTitle": "Assistance" }
